import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/marketing/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/apps/marketing/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/app/apps/marketing/components/fragments/cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/apps/marketing/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/packages/ui/src/components/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
